/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'og-simple-details',
  templateUrl: './simple-details.component.html',
  styleUrls: ['./simple-details.component.scss'],
  standalone: false
})
export class SimpleDetailsComponent {
  /** The card title to display  */
  @Input() title: string;
  /** Defines if the details are editable */
  @Input() isEditable: boolean;
  /** Defines if the details are loading */
  @Input() isLoading: boolean;
  /** Emits save button clicks */
  @Output() saveButtonClicked = new EventEmitter<void>();

  isEditModeActive = false;

  propagateSaveButtonClick(): void {
    this.isEditModeActive = false;
    this.saveButtonClicked.next();
  }
}
